import constate from "constate"
import { useRouter } from "next/router"
import { useEffect } from "react"
import useHelpMenu from "state/useHelpMenu"
import removeQueryString from "utils/removeQueryString"

const [TeamProfileModalProvider, useTeamProfileModal] = constate(() => {
    const router = useRouter()
    const { team } = router.query
    const uuid = team as string
    const isOpen = !!uuid

    const { maybeSetIsVisible } = useHelpMenu()

    useEffect(() => {
        // hides Intercom when modal is visible
        maybeSetIsVisible(!isOpen)
    }, [isOpen, maybeSetIsVisible])

    const showModal = (uuid: string) =>
        router.push({ query: { ...router.query, team: uuid } }, undefined, {
            shallow: true,
        })

    const hideModal = () =>
        removeQueryString(router, ["team"], { shallow: true })

    return {
        team: uuid,
        isOpen,
        showModal,
        hideModal,
    }
})

export { TeamProfileModalProvider, useTeamProfileModal }
